import { gql } from '@apollo/client';

export const QUERY_CUSTOMER_CRITERIA = gql`
  query QUERY_CUSTOMER_CRITERIA {
    customerCriteria @client {
      viewCustomer
      sortByCustomer
      searchCustomer
    }
  }
`;

export const MUTATION_UPDATE_VIEW = gql`
  mutation UpdateViewCustomer($view: String!) {
    updateViewCustomer(view: $view) @client
  }
`;

export const MUTATION_UPDATE_SORT_BY = gql`
  mutation UpdateSortByCustomer($sortBy: String!) {
    updateSortByCustomer(sortBy: $sortBy) @client
  }
`;

export const MUTATION_UPDATE_SEARCH = gql`
  mutation UpdateSearchCustomer($search: String!) {
    updateSearchCustomer(search: $search) @client
  }
`;

export const MUTATION_RESET_SEARCH = gql`
  mutation ResetSearchValuesCustomer($view: String!) {
    resetSearchValuesCustomer @client
  }
`;
